
import { Tooltip } from 'bootstrap';

const initTooltips = (root = document) => {
    const triggerList = Array.from(root.querySelectorAll('[data-bs-toggle="tooltip"]'));
    triggerList.forEach((el) => {
        Tooltip.getOrCreateInstance(el);
    });
}

document.addEventListener('livewire:init', () => {

    initTooltips();

    if (Livewire) {

        Livewire.hook('morphed', ({ el /*, component */ }) => {
            initTooltips(el);
        });

        Livewire.hook('morph.removed', ({ el }) => {
            if (el.matches?.('[data-bs-toggle="tooltip"]')) {
                Tooltip.getInstance(el)?.dispose();
            }
            el.querySelectorAll?.('[data-bs-toggle="tooltip"]').forEach((n) => {
                Tooltip.getInstance(n)?.dispose();
            });
        });

    }

    window.addEventListener('livewire:navigated', () => initTooltips());
});